@switch (specificTemplateName) {
  @case (drillsTemplateNames.Overview) {
    <app-drills-overview-template
      [element]="element"
      [columnName]="columnName"
    ></app-drills-overview-template>
  }
  @case (drillsTemplateNames.Log) {
    <app-drills-log-template
      [element]="element"
      [columnName]="columnName"
    ></app-drills-log-template>
  }
  @default {
    <app-default-cell [element]="element" [columnName]="columnName"></app-default-cell>
  }
}
